import { createRoutine } from 'redux-saga-routines';

export const checkPositionNameRoutine = createRoutine('CHECK_MERGED_POSITION_NAME');
export const mergePositionsRoutine = createRoutine('MERGE_POSITIONS');
